import { useQueries, useQuery } from '@tanstack/react-query';

import { CerberusApi } from '@hcs/cerberus';
import {
  ZipListingStatsTimeSeriesDocument,
  ZipListingStatsTimeSeriesQuery,
  ZipListingStatsTimeSeriesQueryVariables,
} from '@hcs/types';

import { zipListingStatsTSToCerberusListingStats } from '../utils/cerberus-stats.utils';

const QUERY_KEY_ZIP_LISTING_STATS_TIME_SERIES = 'zip-listing-stats-time-series';

export const useZipListingStatsTimeSeries = ({
  zipcode,
  fromDate,
  toDate,
  enabled = true,
  propertyType = 'singleFamily',
}: ZipListingStatsTimeSeriesQueryVariables & {
  enabled?: boolean;
  propertyType?: 'singleFamily' | 'condo';
}) => {
  return useQuery({
    queryKey: [
      QUERY_KEY_ZIP_LISTING_STATS_TIME_SERIES,
      zipcode,
      fromDate,
      toDate,
      propertyType,
    ],

    queryFn: async () => {
      const response = await CerberusApi.fetchQuery<
        ZipListingStatsTimeSeriesQuery,
        ZipListingStatsTimeSeriesQueryVariables
      >(ZipListingStatsTimeSeriesDocument, {
        zipcode,
        fromDate,
        toDate,
      });
      return zipListingStatsTSToCerberusListingStats(response, propertyType);
    },

    enabled,
  });
};

export const useMultipleZipListingStatsTimeSeries = ({
  zips,
  fromDate,
  toDate,
}: {
  zips: Array<ZipListingStatsTimeSeriesQueryVariables['zipcode']>;
  fromDate: ZipListingStatsTimeSeriesQueryVariables['fromDate'];
  toDate: ZipListingStatsTimeSeriesQueryVariables['toDate'];
}) => {
  return useQueries({
    queries: zips.map((zipcode) => {
      return {
        queryKey: [
          QUERY_KEY_ZIP_LISTING_STATS_TIME_SERIES,
          zipcode,
          fromDate,
          toDate,
        ],
        queryFn: async () => {
          const response = await CerberusApi.fetchQuery<
            ZipListingStatsTimeSeriesQuery,
            ZipListingStatsTimeSeriesQueryVariables
          >(ZipListingStatsTimeSeriesDocument, {
            zipcode,
            fromDate,
            toDate,
          });
          return zipListingStatsTSToCerberusListingStats(response);
        },
      };
    }),
  });
};
